import { sendMessageApi as generatedApi } from '../generated/conversations/sendMessage';

import { getConversationMessagesApi } from './getConversationMessages';

import type { ConversationMessageItem } from './getConversationMessages';

const sendMessageApi = generatedApi.enhanceEndpoints({
  endpoints: {
    sendMessage: {
      onQueryStarted: async ({ body: { content }, conversationId }, { dispatch, queryFulfilled }) => {
        const tempId = `temp-${Date.now()}`;

        const optimisticMessage: ConversationMessageItem = {
          content,
          conversation: conversationId,
          id: tempId,
          messageType: 'text',
          platform: 'web',
          role: 'user',
          sender: { firstName: '', id: '', lastName: '', name: '', senderType: 'master' },
          status: 'sending',
          timestamp: new Date().toISOString(),
        };

        const patchResult = dispatch(
          getConversationMessagesApi.util.updateQueryData('getConversationMessages', { conversationId }, (draft) => {
            draft.data.push(optimisticMessage);
            draft.meta.totalItems += 1;
          }),
        );

        try {
          const { data: savedMessage } = await queryFulfilled;

          dispatch(
            getConversationMessagesApi.util.updateQueryData('getConversationMessages', { conversationId }, (draft) => {
              const tempIndex = draft.data.findIndex((m) => m.id === tempId);

              if (tempIndex !== -1) {
                const { status, ...withoutStatus } = optimisticMessage;

                draft.data[tempIndex] = {
                  ...withoutStatus,
                  ...savedMessage,
                  sender: savedMessage.sender ?? optimisticMessage.sender,
                } as ConversationMessageItem;
              } else {
                // WebSocket already replaced the temp — update with confirmed data
                const existing = draft.data.find((m) => m.id === savedMessage.id);

                if (existing != null) {
                  Object.assign(existing, savedMessage);
                }
              }
            }),
          );
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useSendMessageMutation } = sendMessageApi;
